"use strict";
// packages/types/src/attachment.ts
Object.defineProperty(exports, "__esModule", { value: true });
